import React, { useState } from 'react';
import { XIcon, CheckCircleIcon, LockIcon } from 'lucide-react';
interface RegistrationModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function RegistrationModal({
  isOpen,
  onClose
}: RegistrationModalProps) {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    whatsapp: '',
    acceptReminders: true
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  if (!isOpen) return null;
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const response = await fetch("https://connect.mailerlite.com/api/subscribers", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiI0IiwianRpIjoiNjRmNDQxMzA1MzNkZjE4YjhhNGI2ZTdmNTNlYTY0ODBhYjUxMzA5ZDcwMzEzMTVlZGQ4OWE0MTEyMmVmYjYzZDFkNTkwYTRmMWE0YmQ4MTYiLCJpYXQiOjE3NzE2OTg1MjQuODYwNzUzLCJuYmYiOjE3NzE2OTg1MjQuODYwNzU2LCJleHAiOjQ5MjczNzIxMjQuODUwMTY5LCJzdWIiOiIyMTUwOTMwIiwic2NvcGVzIjpbXX0.Z-CYdL2A2a36sE9iKF9cfrhHSZA3DhPElVPzliuQMc2aX24aOEOr0biVBTdDY41GfyO4l74YSGzzkMLZCt7gEsS5nGqEbA7S9Br3RjwbUrbfxRFZdqseSP-YVh4E-g3Z6bsrTaigZFUKjo2a7PlLUi2RGouA9POOisI5O6_qB6B5qsXqo-ODgLWJUgoGQUcYXIjG8iz6_L62_H6Iqp03erPt6sAKNsICGJqJAWz46Jlj79v0YQjiUxzVPxeKkNw2vA12BhBm1M90ik2MZQts-pGUuYW4Bpw7JE8rk8k_KdJyRnX7f2udqO3H4yIuZo_jpLk-I0oJm3Jr9oAkAMxi3VjTVF6Ud1qfI5hjM7R84f3DuWIpHAcMt_j9WA1uZvlgUGryPxeDgWIE3gQWv6vRdRxfNmcSxm5Izj_JvC7PS5pzwA0fe8Spt2W8Abtkr2-t3QyNpYRnqBC-94pVjungc9MeXMI1o_tJtICjt7uX-3-LUT-x-9VycDDLhfTiC80C5_gmROiQogc8McJQBO4sxWjgOnRMnLOPjo1I92C3vbb56v7QlEjX-tLYoE_Hlc15vnBziMT48_AsQzLuzS8TvhBGLNGjwFAX4dH3TisIJM7D1trBXTBcW1JeuFmt3WZZpOWxczB5iDszwxOoCDGyMI01CugIE0o2SvYaiSX72cM"
        },
        body: JSON.stringify({
          email: formData.email,
          fields: {
            name: formData.name,
            whatsapp: formData.whatsapp
          },
          groups: ["180038415275787640"]
        })
      });
      if (!response.ok) {
        console.error("Error MailerLite:", await response.text());
        // Aunque falle MailerLite, seguimos con la experiencia del usuario
      }
    } catch (error) {
      console.error("Error de conexión con MailerLite:", error);
      // Igual no frenamos la experiencia del usuario
    } finally {
      setIsSubmitting(false);
      setIsSuccess(true);

      // Redirección SIEMPRE, para no trabar el registro
      window.location.href = "https://project-masterclassslivegracias.magicpatterns.app";
    }
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {
      name,
      value,
      type,
      checked
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm animate-in fade-in duration-200" data-id="element-163">
      <div className="relative w-full max-w-md bg-brand-card border border-brand-cyan/20 rounded-2xl shadow-2xl overflow-hidden animate-in zoom-in-95 duration-200" onClick={e => e.stopPropagation()} data-id="element-164">
        {/* Close Button */}
        <button onClick={onClose} className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors" aria-label="Cerrar modal" data-id="element-165">
          <XIcon className="w-6 h-6" data-id="element-166" />
        </button>

        <div className="p-8" data-id="element-167">
          {isSuccess ? <div className="text-center py-8" data-id="element-168">
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-green-500/20 text-green-500 mb-6" data-id="element-169">
                <CheckCircleIcon className="w-8 h-8" data-id="element-170" />
              </div>
              <h3 className="text-2xl font-bold text-white mb-2" data-id="element-171">
                ¡Registro Exitoso!
              </h3>
              <p className="text-gray-300 mb-6" data-id="element-172">
                Te enviamos los detalles de acceso a tu correo. Preparate para
                la Masterclass.
              </p>
              <button onClick={onClose} className="w-full py-3 px-6 bg-brand-cyan text-brand-bg font-bold rounded-lg hover:bg-cyan-400 transition-colors" data-id="element-173">
                Entendido
              </button>
            </div> : <>
              <div className="text-center mb-8" data-id="element-174">
                <h2 className="text-2xl font-bold text-white mb-2" data-id="element-175">
                  COMPLETÁ TU REGISTRO
                </h2>
                <p className="text-brand-cyan text-sm font-medium" data-id="element-176">
                  CUPOS LIMITADOS - RESERVÁ AHORA
                </p>
              </div>

              <form onSubmit={handleSubmit} className="space-y-5" data-id="element-177">
                <div data-id="element-178">
                  <label htmlFor="name" className="block text-sm font-medium text-gray-300 mb-1" data-id="element-179">
                    Nombre completo
                  </label>
                  <input type="text" id="name" name="name" required value={formData.name} onChange={handleChange} className="w-full px-4 py-3 bg-brand-bg border border-gray-700 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-brand-cyan focus:ring-1 focus:ring-brand-cyan transition-all" placeholder="Tu nombre" data-id="element-180" />
                </div>

                <div data-id="element-181">
                  <label htmlFor="email" className="block text-sm font-medium text-gray-300 mb-1" data-id="element-182">
                    Email
                  </label>
                  <input type="email" id="email" name="email" required value={formData.email} onChange={handleChange} className="w-full px-4 py-3 bg-brand-bg border border-gray-700 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-brand-cyan focus:ring-1 focus:ring-brand-cyan transition-all" placeholder="tu@email.com" data-id="element-183" />
                </div>

                <div data-id="element-184">
                  <label htmlFor="whatsapp" className="block text-sm font-medium text-gray-300 mb-1" data-id="element-185">
                    WhatsApp (para avisarte cuando empiece)
                  </label>
                  <input type="tel" id="whatsapp" name="whatsapp" required value={formData.whatsapp} onChange={handleChange} className="w-full px-4 py-3 bg-brand-bg border border-gray-700 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-brand-cyan focus:ring-1 focus:ring-brand-cyan transition-all" placeholder="+54 9 11..." data-id="element-186" />
                </div>

                <div className="flex items-start gap-3 pt-2" data-id="element-187">
                  <div className="flex items-center h-5" data-id="element-188">
                    <input id="acceptReminders" name="acceptReminders" type="checkbox" checked={formData.acceptReminders} onChange={handleChange} className="w-4 h-4 rounded border-gray-600 bg-brand-bg text-brand-cyan focus:ring-brand-cyan focus:ring-offset-brand-card" data-id="element-189" />
                  </div>
                  <label htmlFor="acceptReminders" className="text-sm text-gray-400 leading-tight" data-id="element-190">
                    Acepto recibir recordatorios de la masterclass por WhatsApp
                    y correo.
                  </label>
                </div>

                <button type="submit" disabled={isSubmitting} className="w-full py-4 px-6 bg-brand-gold text-brand-bg font-bold text-lg rounded-lg hover:bg-yellow-400 transition-colors shadow-[0_0_20px_rgba(245,158,11,0.3)] disabled:opacity-70 disabled:cursor-not-allowed mt-4" data-id="element-191">
                  {isSubmitting ? 'Procesando...' : 'CONFIRMAR REGISTRO'}
                </button>

                <div className="flex items-center justify-center gap-2 text-xs text-gray-500 mt-4" data-id="element-192">
                  <LockIcon className="w-3 h-3" data-id="element-193" />
                  <span data-id="element-194">Tus datos están 100% seguros. No hacemos spam.</span>
                </div>
              </form>
            </>}
        </div>
      </div>
    </div>;
}